export default __webpack_public_path__ + "static/media/Computador v4.60517404.png";